import PropTypes from "prop-types";


import {Dropdown} from "primereact/dropdown";
import React, {useEffect} from "react";





export function ItemSelect(props) {
    const handleChange = (event) => {
        const myValue = props.itemList.find(x => x.id === event.target.value)

        props.setItem({
            id: myValue.id,
            name: myValue.name,
        });
    };
    return (
        <div className="flex flex-fill justify-content-start flex-wrap flex-shrink-0 md:flex-nowrap">
            <Dropdown value={props.item.id} onChange={handleChange} options={props.itemList}
                      optionLabel="name" optionValue="id" disabled={props.disable}
                      placeholder="Item " tooltip="Select Item" variant="filled"
                      autoFocus={true} focusOnHover={true} highlightOnSelect={true} filter className="flex-1 w-10 h-2rem align-items-center justify-content-center"
                      tabIndex={0}/>

        </div>
    )

}


ItemSelect.propTypes = {
    item:PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        }

    ),
    setItem: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,
    itemList: PropTypes.array.isRequired,
}


